<template>
	<b-form
		ref="form"
		@submit.prevent="setDialPost"
	>
		<b-form-group>
			<v-select
				v-model="dial"
				label="Name"
				:options="dialTypes"
			/>
		</b-form-group>

		<b-button
			type="submit"
			variant="info"
		>Add Dial</b-button>
	</b-form>
</template>

<script>
import DialTypeService from "@/api-services/dialtype.service";
import VSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
	name: "SetDial",

	// things we want to use
	components: {
		VSelect
	},

	// data we bind to, dials need a function wrapping this all up, to keep instances seperate
	data: function() {
		return {
			dial: null,
			dialTypes: []
		};
	},

	created() {
		this.fetchDials();
	},

	// things we do to data
	methods: {
		fetchDials() {
			DialTypeService.getAll().then(response => {
				this.dialTypes = response.data;
			});
		},

		setDialPost() {
			this.$emit("add", this.dial);
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/partials/set-dial.vue